<template>
    <div class="badge l-badge">
        <slot></slot>
        <div v-show="count>0" class="l-badge-content" :class="[lClass,lClassSelf]">{{finalCount}}</div>
        <div v-if="content" class="l-badge-content" :class="[lClass,lClassSelf]">{{content}}</div>
        <div v-if="dot" class="l-badge-dot" :class="[lClass,lClassSelf]"></div>
    </div>
</template>

<script>
import { CommonMixins } from '../mixins'
export default {
    name: 'Badge',
    components: {},
    mixins: [CommonMixins],

    props: {
        // 红点模式
        dot: {
            type: Boolean,
            default: false
        },
        // 数字
        count: {
            type: Number,
            default: 0
        },
        // 数字最大值
        maxCount: {
            type: Number,
            default: 99
        },
        // 数字形式
        countType: {
            type: String,
            default: 'overflow'
        },
        // 文字内容
        content: String,
        lClass: {
            type: String,
            default: ''
        },
        lClassSelf: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // finalCount: 0
        }
    },
    computed: {
        finalCount() {
            let res = 0
            switch (this.countType) {
                case 'overflow':
                    res =
                        parseInt(this.count) >= parseInt(this.maxCount)
                            ? `${this.maxCount}+`
                            : this.count
                    break
                case 'ellipsis':
                    res =
                        parseInt(this.count) >= parseInt(this.maxCount)
                            ? `...`
                            : this.count
                    break
                case 'limit':
                    res =
                        parseInt(this.count) >= 999
                            ? parseInt(this.count) >= 9999
                                ? Math.floor((this.count / 10000) * 100) / 100 +
                                  `w`
                                : Math.floor((this.count / 1000) * 100) / 100 +
                                  `k`
                            : this.count
                    break
                default:
                    res = parseInt(this.count)
                    break
            }
            return res
        }
    }
}
</script>
<style lang='stylus'>
.l-badge
    position: relative
    display: inline-block
    line-height: 1
    vertical-align: middle
    &-content
        height: 16px
        min-width: 27px
        max-width: 325px
        transform: translateX(50%)
        padding: 0 4px
        border-radius: 7px 7px 7px 0px
        background-color: #ff474b
        color: #fff
        position: absolute
        top: -5px
        right: -5px
        font-size: 12px
        display: inline-block
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
        line-height: 16px
        text-align: center
        box-sizing: border-box
        z-index: 10
    &-dot
        height: 8px
        width: 8px
        transform: translateX(50%)
        border-radius: 50%
        background-color: #ff474b
        position: absolute
        top: -2px
        right: 0px
</style>
